<template>
    <add-edit-qualification-officer></add-edit-qualification-officer>
</template>

<script>
import AddEditQualificationOfficer from "@/layouts/components/masters/qualification-officers/addedit-officers";
export default {
  components: {
    AddEditQualificationOfficer
  }
};
</script>
